import MoreIcon from "./images/more-icon.svg";

const THRESHOLD = 7;

export const MORE_TAB_LABEL = "More";

export const getPrimaryServices = (list) => {
    if (list.length > THRESHOLD) {
        return [
            ...list.slice(0, THRESHOLD),
            {
                asLink: false,
                label: MORE_TAB_LABEL,
                iconUrl: MoreIcon
            }
        ];
    }

    return list;
};
